import React from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';

import { useLocation, Navigate } from "react-router-dom";
import auth from '../../Firebase/firebase.init';
import Loading from '../Loading/Loading';

const PrivateRoute = ({ children }) => {
    const [user, loading] = useAuthState(auth);
    let location = useLocation();

    if (loading) {
        return <Loading></Loading>
    }
    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }
    return children;
};

export default PrivateRoute;